// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-765b92b9]{color:#c81919}.my--leads-container[data-v-765b92b9]{position:relative}@media only screen and (max-width: 768px){.my--leads-container[data-v-765b92b9]{padding:16px 24px}}", ""]);
// Exports
module.exports = exports;
